import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import "../CreateProjectModal.css";

interface Props {
  taskTitle: string;
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

// Centre confirm modal for clearing a task's model solution (Ophelia style,
// mirrors DeletePaperModal). The actual DELETE call lives in the card so it can
// refresh the task list; this only gathers the confirmation.
export function DeleteSolutionModal({ taskTitle, busy, onConfirm, onClose }: Props) {
  const { t } = useTranslation();
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape" && !busy) onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, busy]);

  return (
    <div
      className="modal-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !busy) onClose();
      }}
    >
      <div
        className="modal-card"
        role="dialog"
        aria-modal="true"
        aria-label={t("model_solution_panel.delete_title")}
      >
        <button
          type="button"
          className="modal-close"
          onClick={onClose}
          disabled={busy}
          aria-label={t("common.close")}
        >
          ✕
        </button>

        <h2 className="modal-card__title">{t("model_solution_panel.delete_title")}</h2>
        <p className="wipe-paper-name">{taskTitle}</p>

        <div className="wipe-warning">{t("model_solution_panel.delete_confirm")}</div>

        <div className="modal-actions">
          <button
            type="button"
            className="modal-btn modal-btn--ghost"
            onClick={onClose}
            disabled={busy}
          >
            {t("common.cancel")}
          </button>
          <button
            type="button"
            className="modal-btn modal-btn--danger"
            disabled={busy || confirmed}
            onClick={() => {
              setConfirmed(true);
              onConfirm();
            }}
          >
            {busy ? t("model_solution_panel.deleting") : t("common.delete")}
          </button>
        </div>
      </div>
    </div>
  );
}
